export const MessageKeys = {
    'BusinessTransactionTypeId': 'BusinessTransactionTypeId',
    'BusinessTransactionWipStatusId': 'BusinessTransactionWipStatusId',
    'SourceSystemTypeId': 'SourceSystemTypeId',
    'BusinessTransactionNumber': 'BusinessTransactionNumber',
    'ActionSetId': 'ActionSetId',
    'TabTitle': 'TabTitle',
    'TabName': 'TabName',
    'ConfirmActionSetId': 'ConfirmActionSetId',
    'AgentId': 'AgentId',
    'AuxRoutes': 'AuxRoutes',
    'Route': 'Route',
    'ValidationResults': 'ValidationResults',
    'AppendValidationResults': 'AppendValidationResults',
    'RouteConfiguration': 'RouteConfiguration',
    'TemplateTitle': 'TemplateTitle',
    'TransactionObject': 'TransactionObject',
    'SummaryInformation': 'SummaryInformation',
    'ValidationGroups': 'ValidationGroups',
    'SearchResults': 'SearchResults',
    'SearchParameters': 'SearchParameters',
    'CreditAmount': 'CreditAmount',
    'CreditPrimaryCustomer': 'CreditPrimaryCustomer',
    'ButtonTitle': 'ButtonTitle',
    'OutletName': 'OutletName',
    'OverlayText': 'OverlayText',
    'ValidationResourceId': 'ValidationResourceId'
};
